module.exports = __webpack_public_path__ + "media/music.3e60a192.mp3";